import { createKeyedItemKey, createSelectedValuesFilter } from '@deephaven/jsapi-utils';
import { isSelectionMaybeInvertedEqual, useDebouncedValue, useIsEqualMemo, useMappedSelection } from '@deephaven/react-hooks';
import { useMemo } from 'react';
import useTableUtils from "./useTableUtils.js";
export var DEBOUNCE_MS = 300;
/**
 * Creates a filter factory for the current selected keys of a viewport. The
 * selected keys will be mapped to values to match in a given column name. The
 * resulting filter factory is debounced to allow some cushion for cases where
 * a user rapidly changes selections, e.g. in a checkbox list.
 */
export function useDebouncedViewportSelectionFilter(_ref) {
  var viewportData = _ref.viewportData,
    columnName = _ref.columnName,
    shouldSelectAllOnNoSelection = _ref.shouldSelectAllOnNoSelection,
    mapItemToValue = _ref.mapItemToValue;
  var tableUtils = useTableUtils();

  // Map selection to values contained in the column to filter
  var valuesSelection = useMappedSelection(viewportData, mapItemToValue, createKeyedItemKey);

  // Debounce so user can rapidly select multiple items in a row without the
  // cost of updating the table on each change
  var _useDebouncedValue = useDebouncedValue(valuesSelection, DEBOUNCE_MS),
    debouncedValuesSelection = _useDebouncedValue.value;

  // In cases where a user rapidly selects then deselects the selection
  // reference will change, but the state it represents will remain unchanged.
  // Memoize based on the selection value to avoid unnecessarily re-applying
  // table filters.
  var memoValuesSelection = useIsEqualMemo(debouncedValuesSelection, isSelectionMaybeInvertedEqual);
  return useMemo(() => createSelectedValuesFilter(tableUtils, columnName, memoValuesSelection.selection, shouldSelectAllOnNoSelection, memoValuesSelection.isInverted), [columnName, memoValuesSelection, shouldSelectAllOnNoSelection, tableUtils]);
}
export default useDebouncedViewportSelectionFilter;
//# sourceMappingURL=useDebouncedViewportSelectionFilter.js.map